import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { ASSISTANT_NAME } from '@/utils/assistant/brand';
type MarvinLogoProps = {
  size?: number;
};
const SOURCE_WIDTH = 732;
const SOURCE_HEIGHT = 851;
const MarvinLogo = t0 => {
  const $ = _c(6);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const t2 = size >= 64;
  let t3;
  if ($[0] !== size) {
    t3 = Math.round(size * SOURCE_WIDTH / SOURCE_HEIGHT);
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== size || $[3] !== t2 || $[4] !== t3) {
    t4 = <Image alt={`${ASSISTANT_NAME} logo`} height={size} priority={t2} src="/marvin.png" width={t3} />;
    $[2] = size;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default MarvinLogo;